import React from "react";
import { Box, Select, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Tooltip as ReactTooltip } from "react-tooltip";

const CreateFolderModal = ({
  modalIsCreateFolderOpen,
  folderNameText,
  handleCreatefolderChange,
  selectedLanguage,
  selectedOption,
  handleSelectFolderAccess,
  options,
  showIcon,
  handlerCreatefolderModelCancel,
  handlecreateFolder,
}) => {
  return (
    modalIsCreateFolderOpen && (
      <div
        className="modal"
        id="MoveFolder"
        style={{ display: "block", backgroundColor: "#8080801c" }}>
        <div className="modal-dialog modal-dialog-centered modal-customelg">
          <div className="modal-content">
            <div className="modal-header pb-1">
              <h4
                className="d-flex align-items-center text-danger fw-bold "
                htmlFor="">
                {selectedLanguage.LstLanguageCodes.UI_CreateFolder}
              </h4>
            </div>
            <div className="modal-body justify-content-center d-flex">
              <div className="col-sm-3">
                <p
                  className="col-form-label font-w500 control res-w  text-word-break"
                  style={{ fontSize: "15px" }}>
                  {selectedLanguage.LstLanguageCodes.UI_NewFolder}:
                </p>
              </div>
              <div className="col-sm-9 ">
                <input
                  type="text"
                  className="form-control red-shadow border-r4 custom-inputBorder"
                  id="Createfoldername"
                  style={{ height: "49px" }}
                  maxLength={20}
                  value={folderNameText}
                  onChange={(e) => handleCreatefolderChange(e)}
                  placeholder={
                    selectedLanguage.LstLanguageCodes.UI_EnterFoldername
                  }
                  title={selectedLanguage.LstLanguageCodes.UI_EnterFoldername}
                />
              </div>
            </div>
            {localStorage.getItem("UserRole") != "RDocsUser" &&
              localStorage.getItem("UserRole") != "RDocsSupportAdmin" && (
                <div className="modal-body  justify-content-center d-flex pt-1 mb-2 ">
                  <div className="col-sm-3">
                    <p
                      className="col-form-label font-w500 control res-w  text-word-break"
                      style={{ fontSize: "15px" }}>
                      {selectedLanguage.LstLanguageCodes.UI_Folderaccess}:
                    </p>
                  </div>

                  <div className="col-sm-9">
                    <Box sx={{ width: "100%" }}>
                      <Select
                        className="w-100 custom-inputBorder"
                        id="dropdown-without-label"
                        displayEmpty
                        value={selectedOption}
                        onOpen={(e) => showIcon(e)}
                        onChange={handleSelectFolderAccess}
                        sx={{
                          width: "100%",
                          backgroundColor: "#fff",
                          borderRadius: "4px",
                          borderWidth: "1px",
                          "& .MuiSelect-select": {
                            padding: "8px 16px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgb(222, 226, 230)",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgb(222, 226, 230)",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgb(222, 226, 230)",
                            boxShadow: "1px 5px 5px -4px rgb(195 198 203)",
                          },
                          "& .MuiMenuItem-root": {
                            color: "black",
                          },
                          "& .MuiMenuItem-root.Mui-selected": {
                            backgroundColor: "rgb(222, 226, 230)",
                          },
                          "& .MuiMenuItem-root.Mui-selected:hover": {
                            backgroundColor: "rgb(222, 226, 230)",
                          },
                          "& .MuiSvgIcon-root": {
                            color: "black",
                          },
                        }}>
                        {options.map((option, i) => (
                          <MenuItem key={option.value} value={option.value}>
                            <ListItemText primary={option.label} />
                            {selectedOption !== option.value && (
                              <ListItemIcon>
                                <div style={{ float: "right" }}>
                                  <InfoIcon
                                    id={option.value + i}
                                    data-toggle="tooltip"
                                    data-html="true"
                                  />
                                  <ReactTooltip
                                    className="folderAccess-tooltip"
                                    style={{ opacity: 1 }}
                                    anchorId={option.value + i}
                                    place="left">
                                    <table className="tooltip-table">
                                      <tr>
                                        <td>
                                          <div className="d-flex flex-column p-1">
                                            <p className="tooltip-text mb-0">
                                              {" "}
                                              {option.value == "0"
                                                ? selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_myfolderInfo
                                                : option.value == "1"
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_SpecificFolderInfo
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_EveryoneFolderInfo}
                                            </p>
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </ReactTooltip>
                                </div>
                              </ListItemIcon>
                            )}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </div>
                </div>
              )}
            <div className="d-flex justify-content-end mb-3 me-3 mt-2">
              <button
                type="button"
                className="btn btn-danger px-4 me-1"
                data-bs-dismiss="modal"
                onClick={(e) => handlerCreatefolderModelCancel()}>
                {selectedLanguage.LstLanguageCodes.UI_Cancel}
              </button>
              <button
                type="button"
                className="btn btn-primary px-4 ms-3"
                onClick={(e) => handlecreateFolder(e)}>
                {selectedLanguage.LstLanguageCodes.UI_Confirm}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
export default CreateFolderModal;
